import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { List } from 'echarts';
import Swal from 'sweetalert2';
import { FinancialassetsService } from './financialassets.service';
import { Financialassetsmodel } from './model/financialassetsmodel';

import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-financialassets',
  templateUrl: './financialassets.component.html',
  styleUrls: ['./financialassets.component.scss']
})
export class FinancialassetsComponent {
  fnancialAssestsForm: FormGroup;
  TotalAmount: any;
  FinancialAssetsdata: any;
  isJump: any;
  NormalRoutng: boolean;
  total: any = 0; disableFinancialAssets: boolean
  showBubbledata: any;
  valid: boolean = true;
  constructor(private FormBuilder: FormBuilder, private FinancialAssetsService: FinancialassetsService, private router: Router, public commonService: CommonService, private sidenav: SideNavService) { }

  ngOnInit() {
    this.commonService.getNotesData();
    this.commonService.getIncomeStatementsHeaders();
    this.createFinancialassets();
      this.getFinancialassets();
      this.clearfield();
    this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.fnancialAssestsForm.controls['APPeriodId'].value).subscribe((data) => {
      this.commonService.showBubble = data[0].ImportStatus
      if (this.commonService.showBubble) {
        this.sidenav.setShowBubble(true)
        this.getFinancialassets_LY()
      }
    })

   
    this.isJump = localStorage.getItem('isJump');
  }

  getFinancialassets() {
    this.FinancialAssetsService.getFinancialassets(this.fnancialAssestsForm.controls['APPeriodId'].value).subscribe((data: any) => {
      debugger
      this.FinancialAssetsdata = data;
      this.formArrayControls.controls.length = 0

      this.fnancialAssestsForm.patchValue(data)

      if (data.fnancialAssestsArray)
        for (let i = 0; i < data.fnancialAssestsArray.length; i++) {
          this.formArrayControls.push(this.FormBuilder.group({
            FinancialYear: data.fnancialAssestsArray[i].FinancialYear?data.fnancialAssestsArray[i].FinancialYear:0 ,
            ItemDescription: data.fnancialAssestsArray[i].ItemDescription ? data.fnancialAssestsArray[i].ItemDescription:0,
          }));
        }

      //if (data.fnancialAssestsArray != null) {
      //  data.fnancialAssestsArray.forEach((x) => {
      //    this.formArrayControls.push(this.FormBuilder.group(x));
      //  })
      //}
      if (localStorage.getItem("SubmitStatus") == "true") {
        this.fnancialAssestsForm.disable();
        this.disableFinancialAssets = true;
        this.fnancialAssestsForm.controls['FreeText'].disable();
        this.fnancialAssestsForm.controls['fnancialAssestsArray'].disable();
      }

      this.fnancialAssestsForm.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      this.fnancialAssestsForm.controls['Total'].disable();
    })
  }

  getFinancialassets_LY() {
    this.FinancialAssetsService.getFinancialassets_LY(this.fnancialAssestsForm.controls['APPeriodId'].value).subscribe((data: any) => {
      debugger
      this.showBubbledata = data;
    })
  }

 
  createFinancialassets() {
    this.fnancialAssestsForm = this.FormBuilder.group({
      Total: new FormControl(null),
      FreeText: new FormControl(null),
      APPeriodId: new FormControl(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)),
      MatchingData: new FormControl(),


      fnancialAssestsArray: this.FormBuilder.array([this.FormBuilder.group({
        ItemDescription: new FormControl(null),
        FinancialYear: new FormControl(null),
      })])
    });
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.fnancialAssestsForm.reset()
        this.fnancialAssestsForm.reset();
        this.formArrayControls.clear();
        this.fnancialAssestsForm.controls['APPeriodId'].patchValue(CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8));
      }
    })
  }

  addFinancialAssets() {
    debugger
    if (this.validations()) {
      this.formArrayControls.push(this.FormBuilder.group({
        ItemDescription: new FormControl(null),
        FinancialYear: new FormControl(null)
      }));
    }
  }

  saveFinancialassets() {
    debugger
    if (this.validations() && this.On_NextFinancialassets()) {
      this.FinancialAssetsService.insertFinancialAssetsGrid(this.fnancialAssestsForm.getRawValue()).subscribe((data) => {
        debugger
        this.fnancialAssestsForm.markAsPristine();
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Financial assets (Fixed asset investments)", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.router.navigate(['/notes'])
        else if (nextPage == "financialassets(fixedassetinvestments)") {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.router.navigate([nextPage]);
        }
        else {
          this.router.navigate([nextPage]);
        }


      })
    }
    else {
      this.NormalRoutng = false;
      return false;
    }
  }

  validations() {
    debugger
    if (this.formArrayControls.length) {
      var data = [];
      for (var j = 0; j < this.formArrayControls.length; j++) {
        var v = this.fnancialAssestsForm.value.fnancialAssestsArray.filter(x => x.ItemDescription == this.formArrayControls.value[j].ItemDescription)
        if (v.length > 1) {
          data = v;
          Swal.fire("Andica Accounts Production", "Item Description is already present.", 'warning');
          return false;
        }
      }
    }
    for (var i = 0; i < this.fnancialAssestsForm.value.fnancialAssestsArray.length; i++) {
      if ((this.fnancialAssestsForm.value.fnancialAssestsArray.length > 0) && (this.fnancialAssestsForm.value.fnancialAssestsArray[i].ItemDescription == null || this.fnancialAssestsForm.value.fnancialAssestsArray[i].ItemDescription == "")) {
        /*Swal.fire("Andica Accounts Production", 'Item description must be completed.', 'warning');*/
        this.valid = false;
        return false;
      }
      else {
        this.valid = true;
      }
    }
    return true;
  }

  On_NextFinancialassets() {
    debugger;
    if (+this.fnancialAssestsForm.controls['Total'].value != +this.fnancialAssestsForm.controls['MatchingData'].value) {
      if (this.commonService.AccountTypeId != 2)
        Swal.fire("Andica Accounts Production", "Total value must be equal to Fixed assets - Investments value in the Balance Sheet.", 'warning');
      else 
        Swal.fire("Andica Accounts Production", "Total value must be equal to Investments and  Other Fixed Assets value in the Trial Balance.", 'warning');

      
      return false;
    }
    return true;
  }

  deleteRow(index) {

    debugger;
    Swal.fire({
      titleText: "Andica Accounts Production",
      text: 'Are you sure you want to delete?',
      icon: "question",
      showCancelButton: true, 
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      allowOutsideClick: false
    }).then((data) => {
      if (data.value) {
        this.formArrayControls.removeAt(index);
        this.CalculationsGrid();
      }
    })
  }

  CalculationsGrid() {
    debugger;
      this.total=0
    if (this.formArrayControls.length) {
      for (var j = 0; j < this.formArrayControls.length; j++) {
        this.total = this.total + +this.formArrayControls.value[j].FinancialYear;
      }
    }


    this.fnancialAssestsForm.controls['Total'].setValue(this.total)
  }

  get formArrayControls() {
    return this.fnancialAssestsForm.controls['fnancialAssestsArray'] as FormArray;
  }

  On_Back() {
    debugger;
    this.fnancialAssestsForm.markAsPristine();
    var backpage;
    backpage = this.commonService.getBackSelection("Financial assets (Fixed asset investments)", this.commonService.NotesList)
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Financial assets (Fixed asset investments)", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }


  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.fnancialAssestsForm.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          debugger;
          this.NormalRoutng = true;
          if (this.saveFinancialassets()) {
            return true;
          }
          else if (!this.NormalRoutng)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }

}
